export default {
  'claimant.firstName': 'Prénom du Demandeur',
  'claimant.lastName': 'Nom de Famille du Demandeur',
  'claimNumber': 'Numéro de réclamation',
  'roadHazardId': 'Identifiant de Danger Routier',
  'invoiceNumber': 'Facture d\'Achat #',
  'dealerId': 'Comerciante',
};